.card {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-4);
  padding: var(--space-6);
  background: #fff;
  border-top: 1px solid rgba(0, 0, 0, 0.05);
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.card h2 {
  margin: 0 0 var(--space-2);
  font-family: var(--font-display);
  letter-spacing: 0.2em;
  text-transform: uppercase;
}

.card p {
  margin: 0;
  color: var(--color-olive);
  font-size: 0.9rem;
}

.link {
  border: 0;
  background: transparent;
  color: var(--color-ember-dark);
  text-transform: uppercase;
  letter-spacing: 0.18em;
  font-size: 0.7rem;
  cursor: pointer;
}

@media (max-width: 768px) {
  .card {
    flex-direction: column;
    align-items: flex-start;
  }
}
